/* eslint-disable react/jsx-pascal-case */
import { Controller, useFormContext } from "react-hook-form";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import TextInputLabelHookForm from "../../../../components/TextInputLabelHookForm";
import TextInputLabelPhone from "../../../../components/TextInputLabelPhone";
import TextInputHookFormDisabled from "../../../../components/TextInputHookFormDisabled";
import SelectHookFormSingle from "../../../../components/SelectHookFormSingle";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import {
  officesOptions,
  officeAddState,
  openRelatedOfficeState,
  officeEditState,
  workFromHome,
  disabled,
} from "../atoms/atoms";
//Hook form Data
import { useGetActiveOfficeBrand } from "../hooks/useGetActiveOfficeBrand";
import { useGetOfficeHierarchyDistricts } from "../hooks/useGetOfficeHierarchyDistricts";
import { useGetActiveOfficeOrigin } from "../hooks/useGetActiveOfficeOrigin";
import { useGetActiveOfficeType } from "../hooks/useGetActiveOfficeType";
import { useGetActiveSalesType } from "../hooks/useGetActiveSalesType";
import { useGetActiveBusinessOperation } from "../hooks/useGetActiveBusinessOperation";
import { useGetActiveChannel } from "../hooks/useGetActiveChannel";
import { useGetActiveTargetSystem } from "../hooks/useGetActiveTargetSystem";
import { useGetOfficeStatusDetails } from "../hooks/useGetOfficeStatusDetails";
import { useGetActiveOfficeStatus } from "../hooks/useGetActiveOfficeStatus";
import { useEffect, useRef, useState } from "react";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import useGetActiveEmployees from "../../Employees/Confie/hooks/useGetActiveEmployees";
import { useEntity } from "../hooks/useGetEntity";
import { useGetOfficeBanks } from "../hooks/useGetOfficeBanks";
import { useGetOfficeAccounts } from "../hooks/useGetOfficeAccounts";
import { useGetAcquisitionName } from "../../Employees/Confie/hooks/useGetAcquisitionNameList";
import { useGetRetailOffices } from "../hooks/useGetRetailOffices";
import CheckBoxHookForm from "components/CheckBoxHookForm";
import { useGetHierarchyOpts } from "modules/CarrierAgreementMgmt/Employees/Confie/hooks/useGetHierarchyOpts";
import NumericInputField from "components/NumericInputField";
import { OFFICEFIELD_PERMISSIONS } from "../permission";

const OfficeGeneralInfo = ({ disableFields, rowForEdit }) => {
  const formMethods = useFormContext();
  const user = useRecoilValue(accountAtom);
  const isEditState = useRecoilValue(officeEditState);
  const isAddState = useRecoilValue(officeAddState);
  const userPermissions = useRecoilValue(permissionsSelector);
  //Field Permissions
  const officeCodeField =
    OFFICEFIELD_PERMISSIONS.fieldpermission_office_officecode;
  const officeNumberField =
    OFFICEFIELD_PERMISSIONS.fieldpermission_office_corporateofficenumber;
  const officeAccountOwnerField =
    OFFICEFIELD_PERMISSIONS.fieldpermission_office_accountOwner;
  const officeIPAddressField =
    OFFICEFIELD_PERMISSIONS.fieldpermission_office_ipAddress;
  const bankAndAccountField =
    OFFICEFIELD_PERMISSIONS.fieldpermission_office_bankAndAccount;
  const officeHierarchyField =
    OFFICEFIELD_PERMISSIONS.fieldpermission_office_officehierarchy;

  const officeOptions = useRecoilValue(officesOptions);

  const [openRelatedOffice, setOpenRelatedOffice] = useRecoilState(
    openRelatedOfficeState
  );
  const setValidWorkFromHome = useSetRecoilState(workFromHome);
  const [isChannelRequired, setIsChannelRequired] = useState(false);
  const setIsDisabled = useSetRecoilState(disabled);
  const [isConvertedOffice, setIsConvertedOffice] = useState(false);
  const [isConvertedOfficeValue, setIsConvertedOfficeValue] = useState("");
  const [refranchisedValue, setRefranchisedValue] = useState();
  const [franchisedValue, setFranchisedValue] = useState();

  const {
    register,
    control,
    formState: { errors },
    setValue,
    watch,
  } = formMethods;

  const { data: retailOffices } = useGetRetailOffices();
  const { data: employees, isLoading: empLoading } = useGetActiveEmployees();
  const officeList = retailOffices?.map((x) => {
    return {
      value: x.value,
      label: x.label,
    };
  });

  const employeeList = employees?.map((x) => {
    return {
      id: x.employeenumber,
      value: x.email ? x.email : x.fullname,
      label: x.fullname + " - " + x.employeenumber,
      email: x.email,
      employeeId: x.employeeId,
      employeeStatus: x.status,
      officeType: x.officeType,
      officeCode: x.officecode,
    };
  });

  const { data: entities, isLoading: entityLoading } = useEntity();

  const isMexico = watch("country")?.toLowerCase()?.includes("mexico");
  const selectedStateCode = watch("stateCode")?.toLowerCase();

  const entityOptions = entities
    ?.filter(
      (x) =>
        x.isActive === true && x.stateCode?.toLowerCase() === selectedStateCode
    )
    .map((ent) => ({
      label: ent.entityName,
      value: ent.entityId,
      stateCode: ent.stateCode,
      entityName: ent.entityName,
    }));

  // Combination of Brand Name and Brand ID
  const { data: officeBdata, isLoading: officeBLoading } =
    useGetActiveOfficeBrand();

  const activeOfficeBrand = officeBdata
    ?.filter((x) => x.state?.toLowerCase() === selectedStateCode)
    .map((resData) => {
      return {
        label: resData.brandMarketingName + " - " + resData.brandName,
        value: resData.brandId,
        brandName: resData.brandName,
        state: resData.state,
        DBA: resData.dba,
        usedInMexico: resData.usedInMexico,
      };
    });

  const { data: acquisitionNames, isFetching: acquisitionNameFetch } =
    useGetAcquisitionName();

  const isMexicoOnly =
    user.isMexico && !user.isFranchise && !user.isNonFranchise;

  const acquisitionNameOpt = acquisitionNames
    ?.filter((x) => {
      if (isMexico || isMexicoOnly) {
        return x.usedInMexico === true;
      } else if (isMexico === false || !user.isMexico) {
        return x.usedInMexico === null || x.usedInMexico === false;
      }
      return true;
    })
    .map((x) => {
      return {
        label: x.acquisitionName,
        value: x.acquisitionId,
      };
    });

  const { data: officeHdata, isLoading: officeHLoading } =
    useGetOfficeHierarchyDistricts();

  const isSuperUser = user.isFranchise && user.isNonFranchise;
  const officeTypeId = watch("officeTypeId");

  const activeOfficeHierarchy =
    officeHdata &&
    officeHdata
      .filter((x) => {
        if (officeTypeId > 0) {
          if (isSuperUser) {
            if (officeTypeId === 12) {
              return x.isFranchise === true;
            } else {
              return x.isFranchise === false;
            }
          }
        }

        return true;
      })
      .map((resData) => ({
        ...resData,
        label: resData.officeHierarchyName + " - " + resData.districtCode,
        value: resData.officeHierarchyId,
      }));

  const { data: activeOfficeOrigins, isLoading: officeOriginsLoading } =
    useGetActiveOfficeOrigin();
  const officeOriginOpts = activeOfficeOrigins
    ?.filter((x) => x.isActive === true)
    .map((x) => {
      return {
        label: x.officeOriginName,
        value: x.officeOriginId,
      };
    });
  const { data: officeTypeData, isLoading: isOfficeTypeLoading } =
    useGetActiveOfficeType();

  const activeOfficeType = officeTypeData
    ?.filter((x) => x.isActive === true)
    .map((c) => {
      return {
        label: c.officeTypeName,
        value: c.officeTypeId,
      };
    })
    ?.sort((a, b) =>
      a.label?.toLowerCase() > b.label?.toLowerCase() ? 1 : -1
    );

  useEffect(() => {
    const franchisedObject = activeOfficeType?.find(
      (x) => x.label === "Franchise"
    );
    if (franchisedObject) {
      setFranchisedValue(franchisedObject.value);
    }
  }, [activeOfficeType]);

  const filteredOfficeType = activeOfficeType?.filter((x) =>
    user.isFranchise && !user.isNonFranchise
      ? x.label?.toLowerCase()?.includes("franchise")
      : !x.label?.toLowerCase()?.includes("franchise")
  );

  const defaultOfficeType = activeOfficeType?.filter(
    (x) => x.label === "Franchise"
  );

  function wfhChecker(e) {
    if (e.target.value?.toLowerCase()?.includes("work from home")) {
      setValidWorkFromHome(true);
    } else {
      setValidWorkFromHome(false);
    }
  }

  const setOfficeCode = (e) => {
    setValue("officeCode", e.target.value);
  };
  useEffect(() => {
    const officeTypeId = watch("officeTypeId");

    const officeTypes = activeOfficeType?.filter(
      (x) => x.value === officeTypeId
    );

    if (officeTypes?.length > 0) {
      if (
        officeTypes[0]?.label?.toLowerCase() === "retail" ||
        officeTypes[0]?.label?.toLowerCase() === "retail partner"
      ) {
        setIsChannelRequired(true);
      } else {
        setIsChannelRequired(false);
      }
    } else {
      setIsChannelRequired(false);
    }
  }, [watch, activeOfficeType, setIsChannelRequired]);

  //Set TenantID Values based on selected OfficeType or Country
  useEffect(() => {
    const officeTypeId = parseInt(watch("officeTypeId")); // Extract the complex expression
    const country = watch("country")?.toLowerCase(); // Extract the complex expression

    const matchedOfficeType = activeOfficeType?.find((x) =>
      Object.values(x).includes(officeTypeId)
    );

    if (matchedOfficeType?.label?.toLowerCase() === "mga") {
      setValue("tenantId", "004");
    } else if (country === "mexico") {
      setValue("tenantId", "003");
    } else {
      setValue("tenantId", "002");
    }
  }, [activeOfficeType, watch, setValue]);

  const { data: officeStatusData, isLoading: activeOfficeStatusLoading } =
    useGetActiveOfficeStatus();

  const franchiseStatus = [
    "Closed - FA Terminated",
    "Closed - FA Pending Termination",
    "Dark - Franchise",
  ];
  const activeOfficeStatus = officeStatusData
    ?.filter((x) => {
      if (
        !user.isFranchise ||
        watch("officeType")?.toLowerCase() !== "franchise"
      ) {
        return !franchiseStatus?.includes(x.status);
      }
      return true;
    })
    ?.map((b) => {
      return {
        label: b.status,
        value: b.officeStatusId,
      };
    });

  useEffect(() => {
    const refranchisedObject = activeOfficeStatus?.find(
      (x) => x.label === "Refranchised"
    );
    if (refranchisedObject) {
      setRefranchisedValue(refranchisedObject.value);
    }
  }, [officeStatusData]);

  const { data: salesTypeData, isLoading: isSalesTypeLoading } =
    useGetActiveSalesType();
  const activeSalesType = salesTypeData?.map((b) => {
    return {
      label: b.salesTypeName,
      value: b.salesTypeId,
    };
  });

  const { data: businessOperation, isLoading: getBusinessLoading } =
    useGetActiveBusinessOperation();

  const businessOptions = businessOperation?.map((b) => {
    return {
      label: b.businessOperationName,
      value: b.businessOperationName,
    };
  });

  const activeTargetSystem = useGetActiveTargetSystem()?.sort((a, b) =>
    a.label?.toLowerCase() > b.label?.toLowerCase() ? 1 : -1
  );

  const { data: channelData, isLoading: isChannelLoading } =
    useGetActiveChannel();
  const activeChannel = channelData
    ?.map((c) => {
      return {
        label: c.channelName,
        value: c.channelId,
      };
    })
    ?.sort((a, b) =>
      a.label?.toLowerCase() > b.label?.toLowerCase() ? 1 : -1
    );

  const { data: officeStatusDetails, isLoading: officeStatusDetailsLoading } =
    useGetOfficeStatusDetails();
  //Set Office Status Details based on the selected Office Status
  const officeStatusDetailsOptions = !watch("officeStatusId")
    ? []
    : officeStatusDetails
        ?.filter(
          (osd) =>
            osd.isActive === true &&
            osd.officeStatusId === watch("officeStatusId")
        )
        .map((x) => {
          return {
            label: x.officeStatusDetailsName,
            value: x.officeStatusDetailsId,
          };
        });
  const { data: officebanks, isLoading: officebanksLoading } =
    useGetOfficeBanks();
  const officeBanksOpt = officebanks?.map((x) => {
    return {
      value: x.bankId,
      label: x.bankName,
    };
  });
  const { data: officeAccounts, isLoading: officeAccountsLoading } =
    useGetOfficeAccounts();
  const officeAccountOpt = officeAccounts?.map((x) => {
    return {
      value: x.accountId,
      label: x.accountNumber,
      bankId: x.officeBankId,
    };
  });
  const bankAccount = officeAccountOpt?.filter(
    (c) => c.bankId === watch("bankId")
  );

  const isBankRequired =
    watch("bankId") === null || watch("bankId") === undefined ? false : true;
  const isOfficeAccountRequired =
    watch("accountId") === null || watch("accountId") === undefined
      ? false
      : true;
  const isDisabledConverted =
    isEditState && !(watch("isConverted") || watch("officeTypeId") === 4);

  //#region SPLC Hierarchy Opts
  const { data: hierarchyData, isLoading: isHierarchyOptsLoading } =
    useGetHierarchyOpts();
  const isFranchiseUser = user.isFranchise && !user.isNonFranchise;

  const filteredOpts =
    hierarchyData &&
    hierarchyData.filter((x) => {
      if (officeTypeId > 0) {
        if (isSuperUser) {
          if (officeTypeId === 12) {
            return x.isFranchise === true && x.hierarchyName !== null;
          } else {
            return x.isFranchise === false && x.hierarchyName !== null;
          }
        }
      }

      if (isFranchiseUser) {
        return x.isFranchise === true && x.hierarchyName !== null;
      } else if (isSuperUser) {
        return x.hierarchyName !== null;
      } else {
        return (
          (x.isFranchise === false || x.isFranchise === null) &&
          x.hierarchyName !== null
        );
      }
    });

  const hierarchyOpts = filteredOpts
    ?.map((x) => {
      return {
        ...x,
        label: `${x.hierarchyName} - ${x.employeeName}`,
        value: x.hierarchyId,
      };
    })
    ?.sort((a, b) => a.label.trim().localeCompare(b.label.trim()));
  //#endregion

  //#region Channel / SPLC and Office Hierarchy field
  const lastOfficeHierarchy = useRef(rowForEdit?.officeHierarchyId ?? null);
  const lastSplcHierarchy = useRef(rowForEdit?.splcHierarchyId ?? null);

  const channelC = watch("channelC");
  const officeValue = watch("officeHierarchyId");
  const splcValue = watch("splcHierarchyId");

  // Keep track of last non-null values
  useEffect(() => {
    if (officeValue) lastOfficeHierarchy.current = officeValue;
  }, [officeValue]);

  useEffect(() => {
    if (splcValue) lastSplcHierarchy.current = splcValue;
  }, [splcValue]);

  useEffect(() => {
    if (channelC === "SPLC") {
      // Restore cached SPLC value when switching to SPLC and clear Office Hierarchy
      setValue("splcHierarchyId", lastSplcHierarchy.current ?? null);
      setValue("officeHierarchyId", null);
    } else {
      // Restore cached Office Hierarchy when switching away from SPLC and clear Splc Hierarchy
      setValue("officeHierarchyId", lastOfficeHierarchy.current ?? null);
      setValue("splcHierarchyId", null);
    }
  }, [channelC, setValue]);
  //#endregion

  // Helper function for resetting mismatched hierarchy
  const resetHierarchyIfMismatch = (
    data,
    idField,
    idValue,
    fieldName,
    selectedTypeId
  ) => {
    const matchedItem = data.find((x) => x[idField] === idValue);

    if (
      matchedItem &&
      ((selectedTypeId === 12 && !matchedItem.isFranchise) ||
        (selectedTypeId !== 12 && matchedItem.isFranchise))
    ) {
      setValue(fieldName, null);
    }
  };

  const isClosed = watch("officeStatus")?.includes("Closed");
  const isPhoneRequired = isAddState || (isEditState && !isClosed);

  return (
    <div className="m-2 bg-white box-shadow rounded-lg h-full p-1 pb-4">
      <div className="text-quinary font-bold font-sans pt-2 -mb-2 px-4">
        General Information
      </div>
      <div className="grid grid-cols-2 px-1 gap-12">
        <div className="flex justify-end place-items-center mb-3 space-x-1 cursor-pointer">
          <label
            className={`cursor-pointer expandedLabel content-center px-1 ${
              isDisabledConverted ? "text-gray-400" : ""
            }`}
          >
            Converted Office:
          </label>

          <CheckBoxHookForm
            name="isConverted"
            type="checkbox"
            className="flex items-center space-x-1 cursor-pointer"
            label=""
            validation={undefined}
            disabled={isDisabledConverted}
            onClick={(e) => {
              const checked = e.target.checked;
              if (checked) {
                setIsConvertedOfficeValue(defaultOfficeType);
                setValue("officeTypeId", franchisedValue);
                setValue("officeType", "Franchise");
                setValue("officeStatusId", refranchisedValue);
                setValue("officeStatusDetailsId", null);
                setValue("officeCode", null);
                setValue("storeNumber", null);
                setIsConvertedOffice(true);
              } else {
                setValue("officeTypeId", null);
                setValue("officeType", "");
                setValue("officeStatusId", null);
                setIsConvertedOffice(false);
              }
            }}
            register={register}
          />
        </div>
        <div className="col-span-1">
          <span className="flex justify-end mr-3">
            {employeeList?.filter(
              (x) =>
                x.value === watch("createdBy") &&
                x.employeeStatus?.toLowerCase() === "inactive"
            )?.length > 0 && (
              <span className="text-xs text-red-600 italic content-center">
                Created By/Account Owner not in active Employee list.
              </span>
            )}
            {employeeList?.filter((x) => x.value === watch("createdBy"))
              ?.length === 0 && (
              <span className="text-xs text-red-600 italic content-center">
                Account Owner has been terminated or is not registered Employee
              </span>
            )}
          </span>
        </div>
      </div>
      <div className="flex justify-left place-items-end space-x-1 cursor-pointer"></div>

      <div className="grid grid-cols-1 md:grid-cols-2 px-4 gap-12">
        <div className="space-y-1">
          <TextInputLabelHookForm
            label="Office Name"
            type="text"
            required={true}
            disabled={disableFields}
            className={
              errors.officeName &&
              errors.officeName.message &&
              "border-2 border-red-500 col-span-2 "
            }
            register={register("officeName", {
              required: {
                value: true,
                message: "Required Field",
              },
            })}
            onKeyUp={(e) => {
              wfhChecker(e);
            }}
          />
          <TextInputLabelHookForm
            label="Office Code"
            type="text"
            required={userPermissions.includes(officeCodeField) && isEditState}
            disabled={
              !userPermissions.includes(officeCodeField) ||
              disableFields ||
              isAddState
            }
            className={
              errors.officeCode &&
              errors.officeCode.message &&
              "border-2 border-red-500 col-span-2 "
            }
            register={register("officeCode", {
              required: {
                value: userPermissions.includes(officeCodeField) && isEditState,
                message: "Required Field",
              },
            })}
            onKeyUp={(e) => {
              setOfficeCode(e);
            }}
          />
          <NumericInputField
            name="storeNumber"
            label="Corporate Office #"
            register={register("storeNumber", {
              required: {
                value:
                  userPermissions.includes(officeNumberField) && isEditState,
                message: "Required Field",
              },
              validate: (v) =>
                userPermissions.includes(officeNumberField) && isEditState
                  ? (v >= 1 && v <= 9999) ||
                    v >= 30000 ||
                    "Value must be between 1-9999 or 30000 above."
                  : undefined,
            })}
            disabled={
              !userPermissions.includes(officeNumberField) ||
              disableFields ||
              isAddState
            }
            required={
              userPermissions.includes(officeNumberField) && isEditState
            }
            pattern="\d{7}"
            type="number"
            error={errors.storeNumber?.message}
            onKeyPress={(event: any) => {
              if (event.target.value > 9999999) {
                event.preventDefault();
              }
            }}
          />

          <Controller
            control={control}
            name="officeTypeId"
            defaultValue={isConvertedOffice ? isConvertedOfficeValue : ""}
            rules={{ required: true }}
            render={({ field }) => (
              <SelectHookFormSingle
                field={field}
                onChange={(e) => {
                  field.onChange(e ? e.value : null);
                  setValue("officeType", e ? e.label : null);

                  if (!e) {
                    setValue("officeHierarchyId", null);
                    setValue("splcHierarchyId", null);
                  }

                  // Reset hierarchy if it doesn't match the selected type
                  if (isSuperUser) {
                    const selectedTypeId = e ? e.value : null;
                    const currentHierarchy = watch("officeHierarchyId");
                    const currentSplcHierarchy = watch("splcHierarchyId");

                    if (currentHierarchy) {
                      resetHierarchyIfMismatch(
                        officeHdata,
                        "officeHierarchyId",
                        currentHierarchy,
                        "officeHierarchyId",
                        selectedTypeId
                      );
                    }

                    if (currentSplcHierarchy) {
                      resetHierarchyIfMismatch(
                        hierarchyData,
                        "hierarchyId",
                        currentSplcHierarchy,
                        "splcHierarchyId",
                        selectedTypeId
                      );
                    }
                  }

                  if (e) {
                    const filterdEmp = employeeList?.filter(
                      (x) =>
                        x.officeType === e.label &&
                        x.officeCode !== "" &&
                        x.officeCode !== null
                    );

                    const managerFromFilteredEmp = filterdEmp?.filter(
                      (x) => x.employeeId === watch("branchManagerId")
                    );
                    if (managerFromFilteredEmp?.length < 1) {
                      setValue("branchManagerId", null);
                    }
                    if (
                      e.label &&
                      (e.label?.toLowerCase() === "operations" ||
                        e.label?.toLowerCase() === "shell office" ||
                        e.label?.toLowerCase() === "virtual office" ||
                        e.label?.toLowerCase() === "web office" ||
                        e.label?.toLowerCase() === "claims" ||
                        e.label?.toLowerCase() === "corporate" ||
                        e.label?.toLowerCase() === "mga" ||
                        e.label?.toLowerCase() === "affiliate")
                    ) {
                      setValue("channelId", null);
                      setValue("channelC", null);
                      setValue("salesTypeId", null);
                    }
                  }
                }}
                value={field.value}
                options={
                  user.isFranchise && user.isNonFranchise
                    ? activeOfficeType
                    : filteredOfficeType
                }
                isLoading={isOfficeTypeLoading}
                label="Office Type"
                className={
                  errors.officeTypeId && "border-2 border-red-500 col-span-2 "
                }
                required={true}
                isDisabled={disableFields}
              />
            )}
          />

          <Controller
            control={control}
            name="channelId"
            rules={{ required: isChannelRequired }}
            render={({ field }) => (
              <SelectHookFormSingle
                field={field}
                onChange={(e) => {
                  field.onChange(e ? e.value : null);
                  setValue("channelC", e ? e.label : null);
                }}
                value={field.value}
                options={activeChannel}
                isLoading={isChannelLoading}
                label="Channel"
                className={
                  errors.channelId && "border-2 border-red-500 col-span-2 "
                }
                required={isChannelRequired}
                isDisabled={disableFields}
              />
            )}
          />
          {["Retail", "Franchise", "Retail Partner"].includes(
            watch("officeType")
          ) && (
            <Controller
              control={control}
              name="salesTypeId"
              rules={{ required: true }}
              render={({ field }) => (
                <SelectHookFormSingle
                  field={field}
                  onChange={(e) => {
                    field.onChange(e ? e.value : null);
                  }}
                  value={field.value}
                  options={activeSalesType}
                  isLoading={isSalesTypeLoading}
                  label="Sales Type"
                  className={
                    errors.salesTypeId && "border-2 border-red-500 col-span-2 "
                  }
                  required={true}
                  isDisabled={disableFields}
                />
              )}
            />
          )}
          <Controller
            control={control}
            name="officeOriginId"
            rules={{ required: true }}
            render={({ field }) => (
              <SelectHookFormSingle
                field={field}
                onChange={(e) => {
                  field.onChange(e ? e.value : null);
                  setValue("officeOrigin", e ? e.label : null);
                }}
                value={field.value}
                options={officeOriginOpts}
                isLoading={officeOriginsLoading}
                label="Office Origin"
                className={
                  errors.officeOriginId && "border-2 border-red-500 col-span-2 "
                }
                required={true}
                isDisabled={disableFields}
              />
            )}
          />

          <Controller
            name="officeStatusId"
            rules={{ required: true }}
            render={({ field }) => (
              <SelectHookFormSingle
                field={field}
                onChange={(e) => {
                  field.onChange(e ? e.value : null);
                  setValue("officeStatus", e ? e.label : null);
                  if (
                    officeStatusDetails
                      ?.filter(
                        (osd) =>
                          osd.isActive === true &&
                          osd.officeStatusId === watch("officeStatusId")
                      )
                      ?.filter(
                        (x) =>
                          x.officeStatusDetailsId ===
                          watch("officeStatusDetailsId")
                      )?.length < 1
                  ) {
                    setValue("officeStatusDetailsId", null);
                    setValue("officeStatusDetails", null);
                  }
                  if (!watch("officeStatus").includes("Closed")) {
                    setIsDisabled(false);
                  }
                }}
                value={field.value}
                options={activeOfficeStatus}
                label="Office Status"
                className={
                  errors.officeStatusId && "border-2 border-red-500 col-span-2 "
                }
                required={true}
                isDisabled={disableFields}
                isLoading={activeOfficeStatusLoading}
              />
            )}
          />

          <Controller
            control={control}
            name="officeStatusDetailsId"
            rules={{ required: true }}
            render={({ field }) => (
              <SelectHookFormSingle
                field={field}
                onChange={(e) => {
                  field.onChange(e ? e.value : null);
                  const newStatusDetails = e ? e.label : null;
                  setValue("officeStatusDetails", newStatusDetails);

                  if (
                    e?.label &&
                    (e.label?.toLowerCase() === "relocation" ||
                      e.label?.toLowerCase() === "merged" ||
                      e.label?.toLowerCase() === "transferred")
                  ) {
                    setOpenRelatedOffice(true);
                  } else {
                    setOpenRelatedOffice(false);
                  }
                }}
                value={field.value}
                options={officeStatusDetailsOptions}
                isLoading={officeStatusDetailsLoading}
                label="Office Status Details"
                className={
                  errors.officeStatusDetailsId &&
                  "border-2 border-red-500 col-span-2 "
                }
                required={true}
                isDisabled={disableFields}
              />
            )}
          />
          {/* Will be required depends on selected Office Status Details */}
          <Controller
            control={control}
            rules={{ required: openRelatedOffice }}
            name="officeRelated"
            render={({ field }) => (
              <SelectHookFormSingle
                field={field}
                onChange={(e) => {
                  field.onChange(e ? e.value : null);
                }}
                value={field.value}
                options={officeOptions?.filter(
                  (office: any) =>
                    office?.value?.toLowerCase() !==
                      watch("officeCode")?.toLowerCase() &&
                    office.value !== null
                )}
                isLoading={false}
                label="Office Related To Office Status Details"
                required={openRelatedOffice}
                className={
                  errors.officeRelated && "border-2 border-red-500 col-span-2 "
                }
                isDisabled={disableFields}
              />
            )}
          />

          {!isEditState && isConvertedOffice && (
            <Controller
              control={control}
              rules={{ required: true }}
              name="convertedFromOffice"
              render={({ field }) => (
                <SelectHookFormSingle
                  field={field}
                  onChange={(e) => {
                    field.onChange(e ? e.value : null);
                  }}
                  value={field.value}
                  options={officeList}
                  isLoading={false}
                  label="Converted From Office: "
                  required={!isEditState && isConvertedOffice}
                  className={
                    errors.convertedFromOffice &&
                    "border-2 border-red-500 col-span-2 "
                  }
                />
              )}
            />
          )}

          <TextInputLabelPhone
            name="phone"
            label="Phone"
            pattern="(\(\d{3}\)) \d{3}-\d{4}"
            title="Format: (000) 000-0000"
            required={isPhoneRequired}
            disabled={disableFields}
            className={
              errors.phone &&
              errors.phone.message &&
              "border-2 border-red-500 col-span-2 "
            }
            register={register("phone", {
              required: {
                value: isPhoneRequired,
                message: "Required Field",
              },
            })}
            onChange={(e) => {
              var x = e.target.value
                .replace(/\D/g, "")
                .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
              e.target.value = !x![2]
                ? x![1]
                : "(" + x![1] + ") " + x![2] + (x![3] ? "-" + x![3] : "");
            }}
          />
          <TextInputLabelPhone
            name="fax"
            label="Fax"
            pattern="(\(\d{3}\)) \d{3}[-]\d{4}"
            title="Format: (000) 000-0000"
            register={register("fax", {})}
            disabled={disableFields}
            onChange={(e) => {
              var x = e.target.value
                .replace(/\D/g, "")
                .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
              e.target.value = !x![2]
                ? x![1]
                : "(" + x![1] + ") " + x![2] + (x![3] ? "-" + x![3] : "");
            }}
          />
        </div>
        <div className="space-y-1">
          <Controller
            control={control}
            name="createdBy"
            rules={{ required: false }}
            render={({ field }) => (
              <SelectHookFormSingle
                field={field}
                onChange={(e) => {
                  field.onChange(e ? e?.value : null);
                  setValue("accountOwner", e?.value);
                }}
                isClearable={false}
                value={field.value}
                options={employeeList}
                isLoading={empLoading}
                label="Account Owner"
                isDisabled={
                  (userPermissions.includes(officeAccountOwnerField)
                    ? false
                    : true) || disableFields
                }
                required={false}
                className={
                  errors.createdBy && "border-2 border-red-500 col-span-2 "
                }
                placeHolder={
                  field.value?.includes("@")
                    ? field.value
                        ?.split("@")[0]
                        .split(".")
                        .join(" ")
                        .replace(/\b\w/g, (s) => s.toUpperCase())
                    : field.value
                }
              />
            )}
          />
          {watch("channelC") !== "SPLC" ? (
            <Controller
              name="officeHierarchyId"
              control={control}
              render={({ field }) => (
                <SelectHookFormSingle
                  field={field}
                  onChange={(e) => {
                    field.onChange(e ? e.value : isAddState ? undefined : null);

                    // Clear the effective date whenever the hierarchy changes
                    setValue("officeHierarchyEffectiveDate", null);

                    if (e?.value) {
                      setValue("districtName", e.districtName);
                      setValue("districtCode", e.districtCode);
                      setValue("districtManager", e.districtManagerLeader);
                      setValue("areaName", e.areaName);
                      setValue("areaCode", e.areaCode);
                      setValue("salesVP", e.salesVP);
                      setValue("regionName", e.regionName);
                      setValue("regionCode", e.regionCode);
                      setValue("territoryName", e.territoryName);
                      setValue("territoryCode", e.territoryCode);
                      setValue("salesPresident", e.salesPresident);
                      setValue("salesVp", e.salesVP);
                    }
                  }}
                  value={field.value}
                  options={activeOfficeHierarchy}
                  isLoading={officeHLoading}
                  label="Office Hierarchy"
                  isDisabled={
                    (isEditState &&
                      !userPermissions.includes(officeHierarchyField)) ||
                    disableFields
                  }
                />
              )}
            />
          ) : (
            <Controller
              name="splcHierarchyId"
              control={control}
              render={({ field }) => (
                <SelectHookFormSingle
                  field={field}
                  onChange={(e) => {
                    field.onChange(e ? e.value : isAddState ? undefined : null);

                    // Clear the effective date whenever the hierarchy changes
                    setValue("officeHierarchyEffectiveDate", null);

                    if (e?.value) {
                      setValue(
                        "districtHierarchyName",
                        e.districtHierarchyName
                      );
                      setValue(
                        "districtManagerEmployeeName",
                        e.districtManagerEmployeeName
                      );
                      setValue("teamHierarchyName", e.teamHierarchyName);
                      setValue(
                        "teamManagerEmployeeName",
                        e.teamManagerEmployeeName
                      );
                      setValue("stateHierarchyName", e.stateHierarchyName);
                      setValue("directorEmployeeName", e.directorEmployeeName);
                      setValue("marketHierarchyName", e.marketHierarchyName);
                      setValue(
                        "vicePresidentEmployeeName",
                        e.vicePresidentEmployeeName
                      );
                      setValue(
                        "businessUnitHierarchyName",
                        e.businessUnitHierarchyName
                      );
                      setValue(
                        "seniorVicePresidentEmployeeName",
                        e.seniorVicePresidentEmployeeName
                      );
                    }
                  }}
                  value={field.value}
                  options={hierarchyOpts}
                  isLoading={isHierarchyOptsLoading}
                  label="SPLC Hierarchy"
                  isDisabled={
                    (isEditState &&
                      !userPermissions.includes(officeHierarchyField)) ||
                    disableFields
                  }
                />
              )}
            />
          )}
          <Controller
            control={control}
            name="businessOperation"
            render={({ field }) => (
              <SelectHookFormSingle
                field={field}
                onChange={(e) => {
                  field.onChange(e ? e.value : null);
                }}
                value={field.value}
                options={businessOptions}
                isLoading={getBusinessLoading}
                label="Business Operation"
                isDisabled={disableFields}
              />
            )}
          />
          <Controller
            control={control}
            name="entityId"
            rules={{ required: true }}
            render={({ field }) => (
              <SelectHookFormSingle
                field={field}
                onChange={(e) => {
                  field.onChange(e ? e.value : null);
                  setValue("entityName", e?.label);
                }}
                value={field.value}
                isLoading={entityLoading}
                options={entityOptions}
                label="Legal Entity"
                className={
                  errors.entityId && "border-2 border-red-500 col-span-2 "
                }
                required={true}
                isDisabled={
                  disableFields || (watch("stateCode") ? false : true)
                }
                placeHolder={
                  watch("stateCode")
                    ? undefined
                    : "Complete address fields to enable"
                }
              />
            )}
          />
          <Controller
            control={control}
            name="brandId"
            rules={{ required: true }}
            render={({ field }) => (
              <SelectHookFormSingle
                field={field}
                isLoading={officeBLoading}
                onChange={(e) => {
                  field.onChange(e ? e.value : null);
                  if (e?.brandName?.toLowerCase() === "ssb nat") {
                    setValue("nationalCampaignBillingCode", "National NBC");
                  } else {
                    setValue("nationalCampaignBillingCode", watch("stateCode"));
                  }
                  setValue("DBA", e?.DBA);
                }}
                value={field.value}
                options={activeOfficeBrand}
                label="Brand"
                className={
                  errors.brandId && "border-2 border-red-500 col-span-2 "
                }
                required={true}
                isDisabled={
                  disableFields || (watch("stateCode") ? false : true)
                }
                placeHolder={
                  !watch("brandId")
                    ? watch("stateCode")
                      ? undefined
                      : "Complete address fields to enable"
                    : watch("brandName")
                }
              />
            )}
          />
          <Controller
            control={control}
            name="acquisitionId"
            rules={{
              required:
                watch("officeOrigin")?.toLowerCase() === "acquisition" ||
                (watch("officeStatusDetails")?.toLowerCase() ===
                  "acquisition" &&
                  isAddState),
            }}
            render={({ field }) => (
              <SelectHookFormSingle
                field={field}
                isLoading={acquisitionNameFetch}
                onChange={(e) => {
                  field.onChange(e ? e.value : 0);
                  setValue("acquisitionName", e ? e.label : "");
                }}
                value={field.value}
                options={acquisitionNameOpt}
                label="Acquisition Name"
                className={
                  errors.acquisitionId && "border-2 border-red-500 col-span-2 "
                }
                required={
                  watch("officeOrigin")?.toLowerCase() === "acquisition" ||
                  (watch("officeStatusDetails")?.toLowerCase() ===
                    "acquisition" &&
                    isAddState)
                }
                isDisabled={disableFields}
              />
            )}
          />
          <TextInputHookFormDisabled
            name="tenantId"
            label="Tenant Id"
            type="text"
            register={register("tenantId", {})}
          />
          <TextInputLabelHookForm
            name="attendantProfile"
            label="Attendant Profile"
            type="text"
            register={register("attendantProfile", {})}
            disabled={disableFields}
          />
          <Controller
            control={control}
            name="targetSystemId"
            render={({ field }) => (
              <SelectHookFormSingle
                field={field}
                onChange={(e) => {
                  field.onChange(e ? e.value : null);
                }}
                value={field.value}
                options={activeTargetSystem}
                label="Agency Management System"
                isDisabled={disableFields}
              />
            )}
          />
          <TextInputLabelHookForm
            name="ipAddress"
            label="IP Address"
            type="text"
            disabled={
              (userPermissions.includes(officeIPAddressField) ? false : true) ||
              disableFields
            }
            register={register("ipAddress", {})}
          />
          {userPermissions?.includes(bankAndAccountField) && (
            <>
              <Controller
                control={control}
                rules={{
                  required: isOfficeAccountRequired || isBankRequired,
                }}
                name="bankId"
                render={({ field }) => (
                  <SelectHookFormSingle
                    field={field}
                    onChange={(e) => {
                      field.onChange(e ? e.value : null);
                      const account = officeAccountOpt?.filter(
                        (c) => c.bankId === e?.value
                      );
                      if (e) {
                        if (account?.length === 1) {
                          setValue("accountId", account[0]?.value);
                        }
                      }
                      setValue("accountId", null);
                    }}
                    isLoading={officebanksLoading}
                    value={field.value}
                    options={officeBanksOpt}
                    label="Bank"
                    className={
                      isOfficeAccountRequired
                        ? errors.bankId && "border-2 border-red-500 col-span-2 "
                        : ""
                    }
                    required={isOfficeAccountRequired || isBankRequired}
                    isDisabled={disableFields}
                  />
                )}
              />
              <Controller
                control={control}
                rules={{
                  required: isBankRequired || isOfficeAccountRequired,
                }}
                name="accountId"
                render={({ field }) => (
                  <SelectHookFormSingle
                    field={field}
                    onChange={(e) => {
                      field.onChange(e ? e.value : null);
                      setValue("bankId", e ? e.bankId : null);
                    }}
                    isLoading={officeAccountsLoading}
                    value={field.value}
                    options={
                      bankAccount?.length > 0 ? bankAccount : officeAccountOpt
                    }
                    label="Account"
                    className={
                      isBankRequired
                        ? errors.accountId &&
                          "border-2 border-red-500 col-span-2 "
                        : ""
                    }
                    required={isBankRequired || isOfficeAccountRequired}
                    isDisabled={disableFields}
                  />
                )}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default OfficeGeneralInfo;
